import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    GET_FOLDERS: createActionType(FULL_NAMESPACE, "GET_FOLDERS"),
    GET_FOLDERS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_FOLDERS_COMPLETED"),
    SAVE_FOLDER: createActionType(FULL_NAMESPACE, "SAVE_FOLDER"),
    SAVE_FOLDER_COMPLETED: createActionType(FULL_NAMESPACE, "SAVE_FOLDER_COMPLETED"),
    SET_FOLDER: createActionType(FULL_NAMESPACE, "SET_FOLDER"),
    SET_FILE: createActionType(FULL_NAMESPACE, "SET_FILE"),
    SET_FOLDERS: createActionType(FULL_NAMESPACE, "SET_FOLDERS"),
    SET_FILES: createActionType(FULL_NAMESPACE, "SET_FILES"),
    SET_SELECTED_FOLDER: createActionType(FULL_NAMESPACE, "SET_SELECTED_FOLDER"),
    SET_SELECTED_FILE: createActionType(FULL_NAMESPACE, "SET_SELECTED_FILE"),
    GET_FILES: createActionType(FULL_NAMESPACE, "GET_FILES"),
    GET_FILES_COMPLETED: createActionType(FULL_NAMESPACE, "GET_FILES_COMPLETED"),
    SET_MODE_AND_DOCUMENT_ID: createActionType(FULL_NAMESPACE, "SET_MODE_AND_DOCUMENT_ID"),
    DELETE_FOLDER: createActionType(FULL_NAMESPACE, "DELETE_FOLDER"),
    DELETE_FOLDER_COMPLETED: createActionType(FULL_NAMESPACE, "DELETE_FOLDER_COMPLETED"),
    DELETE_FILE: createActionType(FULL_NAMESPACE, "DELETE_FILE"),
    DELETE_FILE_COMPLETED: createActionType(FULL_NAMESPACE, "DELETE_FILE_COMPLETED"),
    UNSET_FOLDER: createActionType(FULL_NAMESPACE, "UNSET_FOLDER"),
    UNSET_FILE: createActionType(FULL_NAMESPACE, "UNSET_FILE"),
    DOWNLOAD_DOCUMENTS: createActionType(FULL_NAMESPACE, "DOWNLOAD_DOCUMENTS"),
    DOWNLOAD_DOCUMENTS_COMPLETED: createActionType(FULL_NAMESPACE, "DOWNLOAD_DOCUMENTS_COMPLETED"),
    DOWNLOAD_DOCUMENTS_REJECTED: createActionType(FULL_NAMESPACE, "DOWNLOAD_DOCUMENTS_REJECTED")
};
